import { Output } from "valibot";

import { LocaleSchema } from "shared/schemas";
import { Literals } from "shared/types";

import translations from "../../translations";

export const hexToRGBA = (hex: string, alpha = 1) => {
  const r = Number.parseInt(hex.slice(1, 3), 16);
  const g = Number.parseInt(hex.slice(3, 5), 16);
  const b = Number.parseInt(hex.slice(5, 7), 16);

  return `rgba(${r},${g},${b},${alpha})`;
};

export const getTypeIcon = (url: string) => {
  const splittedUrl = url.split(".");
  const type = splittedUrl.pop()?.toLowerCase();
  const baseUrl = "https://writesonic.s3.amazonaws.com/frontend-assets/icons/";
  switch (type) {
    case "pdf": {
      return baseUrl + "pdf.png";
    }
    case "docx": {
      return baseUrl + "doc.png";
    }
    case "pptx": {
      return baseUrl + "ppt.png";
    }
    default: {
      return baseUrl + "link.png";
    }
  }
};

function extractFileNameAzure(url: string): string {
  try {
    const urlObj = new URL(url);
    const path = urlObj.pathname;

    const fileNameWithExtension = path.slice(
      Math.max(0, path.lastIndexOf("/") + 1),
    );
    const fileNameWithoutUUID = fileNameWithExtension.replace(
      /^[\dA-Fa-f-]+\./,
      "",
    );

    const decodedFileName = decodeURIComponent(fileNameWithoutUUID);
    return decodedFileName;
  } catch {
    return url;
  }
}

const awsPrefix = "botsonic.s3.amazonaws.com/";
const azureHost = "blob.core.windows.net";
export const getSourceName = (url: string) => {
  try {
    if (url.includes(awsPrefix)) {
      const queryStringStart = url.indexOf("?");
      const pathWithQuery =
        queryStringStart === -1
          ? url
          : url.slice(0, Math.max(0, queryStringStart));
      const pathComponents = pathWithQuery.split("/");
      const filenameWithExtension = pathComponents.at(-1);
      const filenameParts = filenameWithExtension?.split(".");
      filenameParts?.shift(); // Remove the UUID portion
      filenameParts?.pop(); // Remove the extension
      return filenameParts?.join(".") ?? url;
    } else if (url.includes(azureHost)) {
      return extractFileNameAzure(url);
    }

    return url.replace("https://", "");
  } catch {
    return url;
  }
};

export function isFileUrl(string: string) {
  let url;

  try {
    url = new URL(string);
  } catch {
    return false;
  }
  return (
    (url.protocol === "https:" || url.protocol === "http:") &&
    (url.pathname.endsWith(".pdf") ||
      url.pathname.endsWith(".docx") ||
      url.pathname.endsWith(".doc") ||
      url.pathname.endsWith(".pptx") ||
      url.pathname.endsWith(".ppt") ||
      url.pathname.endsWith(".xlsx") ||
      url.pathname.endsWith(".xls") ||
      url.pathname.endsWith(".csv"))
  );
}

/* eslint-disable max-len */
export const getChatPanelText = (
  language: Output<typeof LocaleSchema>,
): Literals => {
  return translations[language];
};
/* eslint-enable max-len */

export function removePeriodsAfterURL(text: string) {
  const urlRegex = /(https?:\/\/\S+)/g;
  const urlMatches = text.match(urlRegex);

  if (urlMatches) {
    for (const url of urlMatches) {
      const lastIndex = url.length - 1;
      if (url[lastIndex] === ".") {
        const urlWithoutPeriod = url.slice(0, Math.max(0, lastIndex));
        text = text.replace(url, urlWithoutPeriod);
      }
    }
  }

  return text;
}
